import React, { useState } from 'react';

import { Link } from '@blockworks/ui/legacy/link';
import { useRouter } from 'next/router';

import NewsletterSubscribeInput from '@/components/pages/frontpage/components/newsletter-subscribe-input';
import subscribeToNewsletter, {
    allNewsletters,
    NewsletterSubscription,
} from '@/utils/functions/subscribe-to-newsletter';
import { newsletterMeta } from '@/components/pages/newsletter/publication/newsletter-publication-static-props';
import SVGCheckbox from '@/components/pages/newsletter/layout/components/svgcheckbox';

const NewsletterPageLayout = () => {
    const router = useRouter();
    const [subscribeTo, setSubscribeTo] = useState<NewsletterSubscription[]>(allNewsletters);
    const source = router.query?.utm_source ? `${router.query?.utm_source}` : 'newsletter-page';
    const campaign = router.query?.utm_campaign ? `${router.query?.utm_campaign}` : '';
    const medium = router.query?.utm_medium ? `${router.query?.utm_medium}` : 'organic';
    const checked = (subscriptionItem: NewsletterSubscription) => {
        const isChecked = subscribeTo.includes(subscriptionItem);
        let updatedSubscribeTo: NewsletterSubscription[] = [...subscribeTo];
        if (isChecked) {
            // Element exists in the array, remove it
            updatedSubscribeTo = updatedSubscribeTo.filter(subscription => subscription !== subscriptionItem);
        } else {
            // Element does not exist in the array, add it
            updatedSubscribeTo.push(subscriptionItem);
        }
        setSubscribeTo(updatedSubscribeTo);
    };

    const newsletters = [
        {
            key: NewsletterSubscription.Daily,
            title: newsletterMeta.daily.title,
            description: newsletterMeta.daily.description,
            url: '/newsletter/daily',
        },
        {
            key: NewsletterSubscription.ResearchDaily,
            title: newsletterMeta.research.title,
            description: newsletterMeta.research.description,
            url: '/newsletter/research',
        },
        {
            key: NewsletterSubscription.Empire,
            title: newsletterMeta.empire.title,
            description: newsletterMeta.empire.description,
            url: '/newsletter/empire',
        },
        {
            key: NewsletterSubscription.Lightspeed,
            title: newsletterMeta.lightspeed.title,
            description: newsletterMeta.lightspeed.description,
            url: '/newsletter/lightspeed',
        },
        {
            key: NewsletterSubscription.OnTheMargin,
            title: newsletterMeta.onthemargin.title,
            description: newsletterMeta.onthemargin.description,
            url: '/newsletter/onthemargin',
        },
    ];

    return (
        <div className="mx-auto pt-10 pb-20">
            <div className="flex gap-20 p-4">
                <div className="flex flex-col justify-center items-start gap-10 max-w-lg">
                    <div className="flex flex-col gap-5">
                        <div className="flex flex-col relative gap-3">
                            <p className="text-[40px] text-left text-[#110b29]">Newsletters</p>
                            <p className="text-2xl text-left text-[#5637cd]">
                                Understand the markets in just 5 minutes
                            </p>
                        </div>
                        <div className="flex justify-start items-center gap-5 w-full">
                            <NewsletterSubscribeInput
                                className="w-full"
                                inputPlaceholder="Enter email address"
                                buttonText="Subscribe"
                                source="newsletter-page"
                                onButtonClick={email =>
                                    subscribeToNewsletter(email, subscribeTo, source, router.asPath, campaign, medium)
                                }
                            />
                        </div>
                    </div>

                    {newsletters.map(newsletter => (
                        <div key={newsletter.title} className="flex justify-center items-start self-stretch gap-4">
                            <SVGCheckbox
                                isChecked={subscribeTo.includes(newsletter.key)}
                                onChecked={() => checked(newsletter.key)}
                                subscriptionKey={newsletter.key}
                            />
                            <div className="flex flex-col justify-start items-start flex-grow gap-4">
                                <div className="flex flex-col justify-start items-start self-stretch relative gap-2">
                                    <div className="flex relative gap-2.5">
                                        <p className="flex-grow text-2xl text-left text-[#110b29] max-w-[500px]">
                                            {newsletter.title}
                                        </p>
                                    </div>
                                    <p className="self-stretch text-base text-left text-[#110b29]">
                                        {newsletter.description}
                                    </p>
                                </div>
                                {newsletter.url && (
                                    <div className="flex justify-start items-center flex-grow-0 flex-shrink-0">
                                        <div className="flex justify-start items-center relative gap-1">
                                            <Link
                                                href={newsletter.url}
                                                className="text-sm text-left uppercase text-primary"
                                            >
                                                subscribe
                                            </Link>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
                <picture className="p-12 hidden lg:block">
                    <img
                        src="/images/newsletter/Phone_Newsletter.png"
                        // srcSet="/images/newsletter/newsletter-phone.png 1x, /images/newsletter/newsletter-phone@2x.png 2x, /images/newsletter/newsletter-phone@3x.png 3x"
                        className="h-[589px] object-cover"
                        alt="phone-newsletter"
                    />
                </picture>
            </div>
        </div>
    );
};

export default NewsletterPageLayout;
